export class Font {
    constructor(
        public id: number,
        public name: string,
        public cssClass: string) { }
}
